import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { WaybillGenerationResponse } from 'models/Waybill';

export const waybillApi = createApi({
  reducerPath: 'waybillApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_TWITTLEBUGS_BASE_URL || '/api',
    prepareHeaders: (headers, { getState }) => {
      // Add your authentication headers
      const token = (getState() as any).app?.accessToken;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('x-functions-key', process.env.REACT_APP_API_HOST_KEY_TWITTLEBUGS);
      }

      return headers;
    }
  }),
  tagTypes: ['Waybill'],
  endpoints: (builder) => ({
    generateWaybill: builder.mutation<
      WaybillGenerationResponse,
      {
        divisionId: string;
        sparingRequestId: string;
      }
    >({
      invalidatesTags: ['Waybill'],
      query: ({ divisionId, sparingRequestId }) => ({
        url: `divisions/${divisionId}/sparingRequests/${sparingRequestId}/generateWaybill`,
        method: 'POST',
        body: {} // Empty JSON body as specified
      })
    }),

    sendWaybillEmail: builder.mutation<
      void, // Return type - your current implementation returns Promise<void>
      {
        divisionId: string;
        sparingRequestId: string;
      }
    >({
      invalidatesTags: ['Waybill'], // Optional: invalidate waybill cache after sending
      query: ({ divisionId, sparingRequestId }) => ({
        url: `divisions/${divisionId}/sparingRequests/${sparingRequestId}/emailWaybills`,
        method: 'POST',
        body: {}
      })
    }),

    getWaybills: builder.query<
      WaybillGenerationResponse,
      {
        divisionId: string;
        sparingRequestId: string;
      }
    >({
      providesTags: ['Waybill'],
      query: ({ divisionId, sparingRequestId }) => ({
        url: `divisions/${divisionId}/sparingRequests/${sparingRequestId}/waybills`,
        method: 'GET'
      })
    })
  })
});

export const { useGenerateWaybillMutation, useGetWaybillsQuery, useSendWaybillEmailMutation } = waybillApi;
